// 🛡️ Sistema de Proteção Anti-DevTools
// Detecta e dificulta tentativas de inspeção do código

class DevToolsProtection {
  constructor() {
    this.isAdmin = false;
    this.isDevelopment = false;
    this.warningShown = false;
    this.debuggerInterval = null;
    this.consoleCheckInterval = null;
    this.init();
  }

  init() {
    // Verificar se usuário é admin ou está em modo desenvolvimento
    this.checkAdminStatus();
    this.checkDevelopmentMode();
    
    // DESABILITAR proteções em desenvolvimento ou para admins
    if (this.isDevelopment || this.isAdmin) {
      console.log('🛡️ Proteções anti-DevTools desabilitadas (Dev/Admin mode)');
      return;
    }
    
    // Proteções apenas para produção E não-admins
    // REMOVIDO: detecção agressiva de DevTools
    // this.detectDevTools(); 
    
    // Proteções leves (apenas console warnings)
    this.protectConsole();
    // REMOVIDO: anti-debugger que trava navegador
    // this.antiDebugger();
    
    // Desabilitar bloqueios agressivos em desenvolvimento
    if (!this.isDevelopment && !this.isAdmin) {
      this.detectRightClick();
      this.detectKeyboardShortcuts();
    }
  }

  checkAdminStatus() {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1]));
        this.isAdmin = payload.role === 'admin';
      }
    } catch (e) {
      this.isAdmin = false;
    }
  }

  checkDevelopmentMode() {
    // Detectar ambiente de desenvolvimento
    this.isDevelopment = 
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname.includes('192.168.') ||
      window.location.port === '3000' ||
      window.location.port === '3001' ||
      process.env.NODE_ENV === 'development';
  }

  // DESABILITADO: Detecção muito agressiva causando falsos positivos
  detectDevTools() {
    // Detecção removida - estava bloqueando usuários legítimos
    // Manter apenas para compatibilidade
    return;
  }

  onDevToolsOpen() {
    if (this.warningShown) return;
    this.warningShown = true;

    // Capturar IP e enviar para backend
    this.reportSuspiciousActivity();

    // Mostrar aviso
    document.body.innerHTML = `
      <div style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999999;
        font-family: 'Segoe UI', sans-serif;
      ">
        <div style="
          background: white;
          padding: 40px;
          border-radius: 20px;
          max-width: 500px;
          text-align: center;
          box-shadow: 0 20px 60px rgba(0,0,0,0.3);
        ">
          <div style="font-size: 64px; margin-bottom: 20px;">🔒</div>
          <h1 style="color: #333; margin-bottom: 20px;">Acesso Não Autorizado</h1>
          <p style="color: #666; line-height: 1.6; margin-bottom: 20px;">
            A tentativa de inspeção foi detectada e registrada.<br>
            <strong>IP, localização e atividades foram capturados.</strong>
          </p>
          <p style="color: #999; font-size: 14px; margin-top: 30px;">
            Se você é um administrador, faça login com suas credenciais.
          </p>
          <button onclick="window.location.reload()" style="
            background: #667eea;
            color: white;
            border: none;
            padding: 12px 30px;
            border-radius: 25px;
            font-size: 16px;
            cursor: pointer;
            margin-top: 20px;
          ">Recarregar Página</button>
        </div>
      </div>
    `;

    // Parar outras proteções
    if (this.debuggerInterval) clearInterval(this.debuggerInterval);
    if (this.consoleCheckInterval) clearInterval(this.consoleCheckInterval);
  }

  async reportSuspiciousActivity() {
    try {
      // Coletar informações
      const data = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        timestamp: new Date().toISOString(),
        url: window.location.href,
        referrer: document.referrer,
        cookiesEnabled: navigator.cookieEnabled
      };

      // Enviar para backend (honeypot)
      fetch('/api/admin-secret', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      }).catch(() => {});
    } catch (e) {
      // Silencioso
    }
  }

  protectConsole() {
    // Sobrescrever console.log
    const noop = () => {};
    const methods = ['log', 'debug', 'info', 'warn', 'error', 'table', 'trace', 'dir', 'group', 'groupEnd'];
    
    methods.forEach(method => {
      const original = console[method];
      console[method] = (...args) => {
        // Permitir logs do próprio sistema
        if (args[0]?.toString().includes('🛡️')) {
          return;
        }
        // Bagunçar console
        if (Math.random() > 0.5) {
          original.apply(console, ['🔒 Acesso restrito']);
        }
      };
    });

    // Mensagem inicial
    console.log('%c🔒 ÁREA PROTEGIDA', 'font-size: 40px; color: red; font-weight: bold;');
    console.log('%cTentativas de inspeção são monitoradas e registradas.', 'font-size: 16px; color: orange;');
    console.log('%cSeu IP e localização serão capturados em caso de atividade suspeita.', 'font-size: 14px;');
  }

  antiDebugger() {
    // DESABILITADO: Debugger statements travam navegador e causam problemas
    // Manter método vazio para compatibilidade
    return;
  }

  detectRightClick() {
    document.addEventListener('contextmenu', (e) => {
      if (!this.isAdmin && !this.isDevelopment) {
        e.preventDefault();
        this.showWarningToast('Clique direito desabilitado');
        return false;
      }
    });
  }

  detectKeyboardShortcuts() {
    document.addEventListener('keydown', (e) => {
      if (!this.isAdmin && !this.isDevelopment) {
        // F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
        if (
          e.key === 'F12' ||
          (e.ctrlKey && e.shiftKey && e.key === 'I') ||
          (e.ctrlKey && e.shiftKey && e.key === 'J') ||
          (e.ctrlKey && e.shiftKey && e.key === 'C') ||
          (e.ctrlKey && e.key === 'U')
        ) {
          e.preventDefault();
          this.showWarningToast('Atalho desabilitado');
          this.reportSuspiciousActivity();
          return false;
        }
      }
    });
  }

  showWarningToast(message) {
    const toast = document.createElement('div');
    toast.textContent = `🔒 ${message}`;
    toast.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #ff4444;
      color: white;
      padding: 15px 25px;
      border-radius: 10px;
      z-index: 999999;
      font-weight: bold;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      animation: slideIn 0.3s ease;
    `;
    
    document.body.appendChild(toast);
    
    setTimeout(() => {
      toast.style.animation = 'slideOut 0.3s ease';
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }

  // Método para desabilitar temporariamente (admin)
  disable() {
    if (this.debuggerInterval) clearInterval(this.debuggerInterval);
    if (this.consoleCheckInterval) clearInterval(this.consoleCheckInterval);
    console.log('🛡️ DevTools Protection disabled (Admin mode)');
  }
}

// Adicionar animações CSS
const style = document.createElement('style');
style.textContent = `
  @keyframes slideIn {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
  @keyframes slideOut {
    from { transform: translateX(0); opacity: 1; }
    to { transform: translateX(100%); opacity: 0; }
  }
`;
document.head.appendChild(style);

// Inicializar proteção
let devToolsProtection;
if (typeof window !== 'undefined') {
  devToolsProtection = new DevToolsProtection();
}

export default devToolsProtection;
